import { get } from '../helpers/fetch';
import config from '../config/config';

export const getStories = async params => {
    const url = `${config.apiUrl}/teams/${config.teamId}/stories`;
    return await get(url, params);
};
